let t = null

export const debounce = function (fn, wait) {
    if(t !== null) {
        clearTimeout(t)
        t = null
    }

    t = setTimeout(() => {
        // 处理参数 去除 fn, wait
        let args = [...arguments].splice(2)
        console.log(args)
        fn.call(this, ...args)
        t = null
    }, wait)
}
// 防抖
export function _debounce(fn, delay) {
 
    var delays = delay || 200;
    var timer;
    return function () {
        var th = this;
        var args = arguments;
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(function () {
            timer = null;
            fn.apply(th, args);
        }, delays);
    };
}
// 节流
export function _throttle(fn, interval) {
    var last;
    var timer;
    var intervals = interval || 200;
    return function () {
        var th = this;
        var args = arguments;
        var now = +new Date();
        if (last && now - last < intervals) {
            clearTimeout(timer);
            timer = setTimeout(function () {
                last = now;
                fn.apply(th, args);
            }, intervals);
        } else {
            last = now;
            fn.apply(th, args);
        }
    }
}